import {
  migrateAllPlainBrowserStorageKeys,
  NativeBrowserStorage,
} from './local-storage-encryption.util';

/**
 * Create direct connection to real browser storage (skips encryption layer).
 * Parameter storage → window.localStorage or window.sessionStorage
 */
function createNativeBrowserStorage(storage: Storage): NativeBrowserStorage {
  return {
    getItem: Storage.prototype.getItem.bind(storage),
    setItem: Storage.prototype.setItem.bind(storage),
    removeItem: Storage.prototype.removeItem.bind(storage),
    clear: Storage.prototype.clear.bind(storage),
    key: Storage.prototype.key.bind(storage),
    get length() {
      return storage.length;
    },
  };
}

let nativeLocalStorage: NativeBrowserStorage | null = null;
let nativeSessionStorage: NativeBrowserStorage | null = null;

/**
 * Get real localStorage. No parameters.
 * Used by LocalStorageKeyService after login to migrate plain data.
 */
export function getNativeLocalStorage(): NativeBrowserStorage {
  nativeLocalStorage ??= createNativeBrowserStorage(window.localStorage);
  return nativeLocalStorage;
}

/**
 * Get real sessionStorage. No parameters.
 */
export function getNativeSessionStorage(): NativeBrowserStorage {
  nativeSessionStorage ??= createNativeBrowserStorage(window.sessionStorage);
  return nativeSessionStorage;
}

/**
 * Migration 4.0.0 — Convert plain data in localStorage and sessionStorage.
 * No parameters. Called from LocalStorageKeyService.initializeFromAccount
 */
export function migrateAllPlainLocalStorageKeys(): void {
  if (typeof window === 'undefined') {
    return;
  }

  migrateAllPlainBrowserStorageKeys(
    getNativeLocalStorage(),
    getNativeSessionStorage()
  );
}
